import { useRef, useState } from "react";
import { UploadCloud, X } from "lucide-react";

export default function BlogBannerUpload({ image, onImageChange }) {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const setFile = (file) => {
    if (file && file.type.startsWith("image/")) {
      onImageChange(URL.createObjectURL(file));
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    setFile(e.dataTransfer.files?.[0]);
  };

  return (
    <div className="bg-white border border-slate-100 shadow-sm rounded-3xl p-6 sm:p-8">
      <h2 className="font-bold text-lg text-slate-900 mb-1">
        Upload Blog Banner
      </h2>
      <p className="text-sm text-slate-500 mb-5">
        Add a beautiful banner image for your blog.
      </p>

      <div
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={handleDrop}
        className={`relative rounded-2xl border-2 border-dashed cursor-pointer transition-colors duration-200 overflow-hidden ${
          isDragging
            ? "border-[#7209B7] bg-purple-50"
            : "border-purple-200 bg-[#F7F3FC]"
        }`}
      >
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => setFile(e.target.files?.[0])}
        />

        {image ? (
          <div className="relative h-64 sm:h-72">
            <img
              src={image}
              alt="Blog banner"
              className="w-full h-full object-cover"
            />
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onImageChange(null);
              }}
              aria-label="Remove banner"
              className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center text-center py-16 px-4">
            <span className="w-14 h-14 rounded-full bg-[#7209B7] flex items-center justify-center mb-4">
              <UploadCloud className="w-6 h-6 text-white" />
            </span>
            <p className="text-sm text-slate-600 mb-1">
              <span className="font-semibold text-[#7209B7]">
                Click to upload
              </span>{" "}
              or drag and drop them here
            </p>
            <p className="text-xs text-slate-400">
              Image Size : (Width 1600 x Hight 600 px Image Formet : JPG /
              Jpeg / Webp
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
